import api from '../../../App/socket';

export const getLivePriceRequest = async (leadId) => {
    return api.send(
        {
            api: 'module',
            module: 'Leads',
            classMethod: 'GetLivePrice',
            options:
                {
                    where:
                        {
                            lead_id: leadId,
                        },
                },
        },
    );
};


// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/getLivePriceRequest.js